var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.195 33.8302C6.12 32.3852 0 25.4151 0 17.0001C0 7.65004 7.65 0 17 0C26.35 0 34 7.65004 34 17.0001C34 25.4151 27.88 32.3852 19.805 33.8302L18.87 33.0652H15.13L14.195 33.8302Z",
    fill: "#FE7C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.63 21.76L24.395 16.9999H19.89V13.6849C19.89 12.3249 20.4 11.3049 22.44 11.3049H24.65V6.96988C23.46 6.79988 22.1 6.62988 20.91 6.62988C17 6.62988 14.28 9.00989 14.28 13.2599V16.9999H10.03V21.76H14.28V33.745C15.215 33.915 16.15 34 17.085 34C18.02 34 18.955 33.915 19.89 33.745V21.76H23.63Z",
    fill: "#00383d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook_logo.174d24c6460af949265a0b17fe125fb2.svg";
export { ForwardRef as ReactComponent };